import request from '@/utils/request';
export const importDept = (data: any) =>
  request({
    url: 'Department/importDepartment',
    method: 'POST',
    data
  });

export const modifyDepartmentParent = (data: any) =>
  request({
    url: 'Department/modifyDepartmentParent',
    method: 'PUT',
    data
  });